<template>
  <div class="setting-online-leave-msg">
    <div class="module-item-style">
      <div class="module-item-title leave-msg-title">
        <div>
          留言引导文案
        </div>
      </div>
      <div class="leave-msg-tips">对话结束后或没有客服的情况下，提示访客留言（最多250个字）</div>
      <div class="leave-msg-content">
        <el-input
            class="input-textarea"
            type="textarea"
            resize="none"
            rows="4"
            maxlength="250"
            show-word-limit
            @blur="saveChange('message_tip',leaveMsgConfig.message_tip)"
            placeholder="请输入内容..."
            v-model="leaveMsgConfig.message_tip">
        </el-input>
      </div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title leave-msg-title">
        <div>
          留言内容模板
        </div>
        <div class="leave-msg-switch-btn">
          <el-switch
              v-model="contentModuleBtn"
              @change="saveChange('message_content_open',contentModuleBtn)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="leave-msg-tips">
        让系统自动填写一些留言内容，帮助更清晰的反馈问题（最多250个字)
      </div>
      <div class="leave-msg-content" v-if="contentModuleBtn">
        <el-input
            class="input-textarea"
            type="textarea"
            resize="none"
            rows="4"
            maxlength="250"
            show-word-limit
            @blur="saveChange('message_content',leaveMsgConfig.message_content)"
            placeholder="请输入内容..."
            v-model="leaveMsgConfig.message_content">
        </el-input>
      </div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title leave-msg-title">
        <div>
          公众号与小程序留言引导文案
        </div>
        <div class="leave-msg-switch-btn">
          <el-switch
              v-model="wxModuleBtn"
              @change="saveChange('isopen_cs_offline_reply',wxModuleBtn)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="leave-msg-tips">让系统自动填写一些留言内容，帮助更清晰的反馈问题（最多250个字)</div>
      <div class="leave-msg-content" v-if="wxModuleBtn">
        <el-input
            class="input-textarea"
            type="textarea"
            resize="none"
            rows="4"
            maxlength="250"
            show-word-limit
            @blur="saveChange('cs_offline_reply_content',leaveMsgConfig.cs_offline_reply_content)"
            placeholder="请输入内容..."
            v-model="leaveMsgConfig.cs_offline_reply_content">
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-online-leave-msg',
    data() {
      return {
        leaveMsgConfig:{
          message_content:'', // 留言模版内容
          cs_offline_reply_content:'', // 公众号与小程序留言引导文案
          message_tip:'', // 留言引导文案
          isopen_cs_offline_reply:false, // 是否开启公众号与小程序留言引导文案
          message_content_open:false, // 是否开启留言内容模板
        },
        contentModuleBtn: false,
        wxModuleBtn: false,
      }
    },
    created() {
      this.getLeaveMsgConfig()
    },
    mounted() {

    },
    methods: {
      getLeaveMsgConfig(){
        this.$http.getLeaveMsgConfigAPI().then( res => {
          if(res.status == 1){
            let leaveInfo = res.data
            this.leaveMsgConfig = leaveInfo
            if(leaveInfo.message_content_open == 1){
              this.contentModuleBtn = true
            }else {
              this.contentModuleBtn = false
            }
            if(leaveInfo.isopen_cs_offline_reply == 1){
              this.wxModuleBtn = true
            }else {
              this.wxModuleBtn = false
            }
          }
        })
      },
      saveChange(name,value) {
        let postValue ;
        if(value == ''){
          postValue = ''
        }else {
          if(value == 'true' || value == true){
            postValue = 1
          }else if (value == 'false' || value == false) {
            postValue = 0
          }else {
            postValue = value
          }
        }

        this.$http.saveConfigAPI({
          name,
          value:postValue
        }).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getLeaveMsgConfig()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss">
  .setting-online-leave-msg {
    .leave-msg-title {
      display: flex;

      .leave-msg-switch-btn {
        margin-left: auto;
      }
    }

    .leave-msg-tips {
      color: #999;
      font-size: 12px;
      padding: 12px 0 15px 0;
    }

    .leave-msg-content {
      .input-textarea {
        width: 600px;
      }
    }
  }
</style>
